const roleRank = { User: 0, Admin: 1, Owner: 2 } as const;

type RankedRole = keyof typeof roleRank;

function rankOf(role: string): number {
  return role in roleRank ? roleRank[role as RankedRole] : 0;
}

export function hasRole(
  roles: string[] | undefined,
  minimum: "Admin" | "Owner",
): boolean {
  const rank = Math.max(0, ...(roles ?? []).map(rankOf));

  return rank >= roleRank[minimum];
}
